import PropTypes from 'prop-types';
import React from 'react';
import { ArrowLeft } from 'react-bootstrap-icons';

import Link from './link';
import useTranslation from '../../hooks/use_translation';

const BtnBack = ({ url }) => {
	const { t } = useTranslation('component_button_back');
	return (
		<Link className="text-decoration-none small px-0 py-2" to={url}>
			<ArrowLeft className="me-1" /> {t('t1')}
		</Link>
	);
};

BtnBack.propTypes = {
	url: PropTypes.string,
};

export default BtnBack;
